$(document).ready(function(){
    //fix height of titles
    var heighest_block = 0;
    $('h5.product__title').css('height', 'auto');
    $('h5.product__title').each(function () {
        if ($(this).innerHeight() > heighest_block) {
        heighest_block = $(this).innerHeight();
        }
    });

    $('h5.product__title').css('height', heighest_block);

    // //fix height of prices
    // var heighest_block = 0;
    // $('.product__price').css('height', 'auto');
    // $('.product__price').each(function () {
    //     if ($(this).innerHeight() > heighest_block) {
    //     heighest_block = $(this).innerHeight();
    //     }
    // });

    // $('.product__price').css('height', heighest_block);

    // if($(window).width() < 786) {
    //     $("#grid").click();
    // }
});
